"use client";
import { useEffect, useLayoutEffect } from "react";
//#region packages/@mantine/hooks/src/use-isomorphic-effect/use-isomorphic-effect.ts
const useIsomorphicEffect = typeof document !== "undefined" ? useLayoutEffect : useEffect;
//#endregion
export { useIsomorphicEffect };

//# sourceMappingURL=use-isomorphic-effect.mjs.map